// @ts-check
import { nextArrow, prevArrow, defaultOptions } from "../global/slick-options";
import { get, getAll } from "../utilities/querySelector";

const contentTop = get("[data-background]");
if (contentTop) {
    const backgroundTarget = get("[data-background-target]");
    contentTop.style.height = `${backgroundTarget.offsetTop}px`;
}

const textChange = getAll("[data-theme-change]");
if (textChange.length) {
    document.addEventListener("scroll", handleThemeChange);
    window.onload = handleThemeChange;

    function handleThemeChange(event) {
        const element1 = get(".content-background");
        const elem1Rect = element1.getBoundingClientRect();

        textChange.forEach((element) => {
            let rect = element.getBoundingClientRect();

            if (
                rect.top + window.scrollY <=
                elem1Rect.bottom + window.scrollY
            ) {
                element.classList.add("theme--dark");
                element.classList.remove("theme--light");
            } else {
                element.classList.add("theme--light");
                element.classList.remove("theme--dark");
            }
        });
    }
}

const galleryMainElem = '[data-slider="single-gallery"]';
const galleryThumbsElem = '[data-slider="single-gallery-nav"]';
const galleryMain = jQuery(galleryMainElem);
const galleryThumbs = jQuery(galleryThumbsElem);
let customOptions = {};

if (galleryMain.length) {
    //if has thumbnails attribute
    if (galleryMain.attr("data-slider-thumbnails") == "true") {
        customOptions = {
            arrows: false,
            draggable: false,
            asNavFor: galleryThumbsElem,
        };
    } else {
        customOptions = {
            draggable: true,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
        };
    }

    galleryMain.slick({
        ...defaultOptions,
        ...customOptions,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}

if (galleryThumbs.length) {
    const galleryThumbsElems = galleryThumbs.find(".slideImage");
    galleryThumbs.slick({
        ...defaultOptions,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: galleryMainElem,
        centerMode: galleryThumbsElems.length < 6 ? true : false,
        centerPadding: "0",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    centerMode: galleryThumbsElems.length < 3 ? true : false,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    centerMode: galleryThumbsElems.length < 4 ? true : false,
                },
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                    centerMode: galleryThumbsElems.length < 4 ? true : false,
                },
            },
        ],
    });
}
